import { FormControl, FormLabel, Switch } from '@mui/joy';
import { Controller } from 'react-hook-form';

import { FlexBox } from 'core/elements';
import { LabelPosition } from 'core/enums';
import { toFieldFocusRef } from 'core/utils/fieldFocus';
import { Direction } from 'theme/enums';

import { DisabledTooltipWrapper } from './DisabledTooltipWrapper';
import { IProps } from './SwitchInput';

export const SwitchInputWithControllerView = ({
  control,
  error,
  name,
  defaultValue = false,
  disabled,
  label,
  onChange,
  onKeyDown,
  size,
  labelSx,
  labelPosition = LabelPosition.END,
  disabledTooltip,
  slotProps,
  ...rest
}: IProps) => {
  const labelContent = (
    <FormLabel sx={{ marginBottom: 0, cursor: !disabled ? 'pointer' : 'default', ...labelSx }}>
      {label}
    </FormLabel>
  );

  return (
    <DisabledTooltipWrapper disabled={disabled} disabledTooltip={disabledTooltip}>
      <Controller
        name={name}
        control={control}
        defaultValue={defaultValue}
        render={({ field }) => (
          <FlexBox>
            <FormControl
              error={Boolean(error)}
              sx={{ display: 'flex', flexDirection: Direction.ROW, alignItems: 'center', gap: 1 }}
            >
              {label && labelPosition === LabelPosition.START && labelContent}

              <Switch
                onKeyDown={onKeyDown}
                onChange={(e) => {
                  onChange?.(e);

                  field.onChange(e.target.checked);
                }}
                onBlur={field.onBlur}
                checked={field.value}
                size={size}
                disabled={disabled}
                {...rest}
                slotProps={{
                  ...slotProps,
                  input: { ...slotProps?.input, name: field.name, ref: toFieldFocusRef(field.ref) },
                }}
              />

              {label && labelPosition === LabelPosition.END && labelContent}
            </FormControl>
          </FlexBox>
        )}
      />
    </DisabledTooltipWrapper>
  );
};
